import {setQuizEntrant as initQuizEntrant}  from './scripts/setQuizEntrant';
import {checkQuizAnswers as initQuiz}  from './scripts/checkQuizAnswers';
import {showResultSummary as initResults}  from './scripts/showResultSummary';
import {fetchQuizStats as initStats}  from './scripts/fetchQuizStats';
import { backButton as backButtonHelper } from './scripts/utils';
import { generateCertificate as initGenerateCertificate } from './scripts/generateCertificate';


document.addEventListener("DOMContentLoaded", () => {
    initQuizEntrant(document.querySelector("[data-quiz-start]"));
    initQuiz(document.querySelectorAll("[data-quiz-question]"));
    initStats(document.querySelector('[data-quiz-counter]'));
    initResults(document.querySelector("[data-quiz-results]"));
    backButtonHelper(document.querySelectorAll("[data-back-button]"));
    initGenerateCertificate(document.querySelector("[data-js-downloadcertificate]"));
});